export default __webpack_public_path__ + "static/media/a.044dcef1.png";